function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRedTriangle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 292 250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M146,1.897L292,249.897L-0,249.897L146,1.897Z",
    style: {
      fill: "rgb(255,58,58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.197,181.649L153.867,181.649L155.144,117.905L136.792,117.905L138.197,181.649ZM145.936,208.641C151.819,208.641 156.04,204.676 156.04,199.049C156.04,193.422 151.819,189.329 145.936,189.329C140.053,189.329 135.96,193.422 135.96,199.049C135.96,204.676 140.053,208.641 145.936,208.641Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRedTriangle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/red-triangle.77d67b2dc21816d91339ac72819fb134.svg";